import React, { createContext, useEffect, useState } from "react";
import axiosInstance from "../services/api/axiosInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { encryptData } from "Security/Crypto/Crypto";

const SuperAdminContext = createContext();

export const DataProvider = ({ children }) => {
  const pageRender = useNavigate();
  const [employerTabSwitching, setemployerTabSwitching] = useState("about_company");
  const [employerJobsSortBy, setemployerJobsSortBy] = useState('All')
  const [isSearched, setIsSearched] = useState(false)
  const [isMilleSearchFiltered, setIsMilleSearchFiltered] = useState(false);
  const [deletionContent, setDeletionContent] = useState("");
  const [deleteRecommendationId, setDeleteRecommendationId] = useState(0);
  const [professionalSearchType, setProfessionalSearchType] = useState('Text search');
  const [professionalClearNotes, setprofessionalClearNotes] = useState(false);
  const [professionalSendNotes, setprofessionalSendNotes] = useState(false);
  const [professionalMakeRecommendation, setprofessionalMakeRecommendation] = useState(false);
  const [employerTotalJobsDetails, setJobEmployerTotalJobsDetails] = useState([])
  const [employerSavingNotes, setemployerSavingNotes] = useState(false);
  const [employerClearNotes, setEmployerClearNotes] = useState(false);
  const [jobMakeRecommendation, setjobMakeRecommendation] = useState(false);
  const [mellieSearchJobPlans, setMellieSearchJobPlans] = useState([]);
  const [minimumDeviceCards, setMinimumDeviceCards] = useState(false);
  const [initialGlow, setInitialglow] = useState(false);
  const [selectedcard, setSelectedCard] = useState(false);
  const [experience, setExperience] = useState([]);
  const [education, setEducation] = useState([]);
  const [skills, setSkills] = useState([]);
  const [video, setVideo] = useState("");
  const [language, setLanguage] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [employerSkills, setEmployerSkills] = useState([]);
  const [smallDevice, setSmallDevice] = useState(false);
  const [hidesidebar, setHideSideBar] = useState(false);
  const [professionalData, setProfessionalData] = useState({});
  const [professionalId, setProfessionalId] = useState(0);
  const [professionalLocationConvertion, setProfessionalLocationConvertion] = useState([]);
  const [professionalSkillConvertion, setProfessionalSkillConvertion] = useState([]);
  const [professionalCards, setProfessionalCards] = useState([]);
  const [professionalCardsDupli, setProfessionalCardsDupli] = useState([]);
  const [professionalSelectedCardData, setProfessionalSelectedCardData] = useState({});
  const [professionalAbout, setProfessionalAbout] = useState("");
  const [professionalPreferences, setProfessionalPreferences] = useState("");
  const [professionalPdf, setProfessionalPdf] = useState("");
  const [professionalSocialLinks, setProfessionalSocialLinks] = useState([]);
  const [professionalkeepNotes, setProfessionalKeepNotes] = useState("");
  const [makeRecommendationLoading, setMakeRecommendationLoading] = useState(false);
  const [recCompanyList, setRecCompanyList] = useState([]);
  const [recommendedProfiles, setRecommendedProfiles] = useState([]);
  const [deletingCardId, setDeletingCardId] = useState(0);
  const [professionalApplyFilterCount, setProfessionalApplyFilterCount] = useState(0);
  const [professionalApplyFilterObject, setProfessionalApplyFilterObject] = useState({});
  const [professionalSearch, setProfessionalSearch] = useState("");
  const [professionalExpertNotes, setProfessionalExpertNotes] = useState("");
  const [professionalFilter, setProfessionalFilter] = useState(false);
  const [professionalPagination, setProfessionalPagination] = useState(false);
  const [superAdminProfessionalSearch, setsuperAdminProfessionalSearch] = useState('');
  const [profmellieSearchSkills, setProfMellieSearchSkills] = useState([]);
  const [profmellieSearchLocations, setProfMellieSearchLocations] = useState([]);
  const [profmellieSearchPlans, setProfMellieSearchPlans] = useState([]);

  //pagination
  const [paginationTotalCount, setPaginationTotalCount] = useState(0);
  const [paginationpageCount, setPaginationpageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const pageRange = 10;

  // super admin job states
  const [employerTakeNotes, setEmployerTakeNotes] = useState("");
  const [employerOpen, setEmployerOpen] = useState(false);
  const [jobCandidateListResponse, setjobCandidateListResponse] = useState(false);
  const [jobApplyFilterObject, setjobApplyFilterObject] = useState({});
  const [jobApplyFilterLoading, setJobApplyFilterLoading] = useState(false);


  const [skillss, setSkillss] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [jobStatusSelect, setJobStatusSelect] = useState([])
  // const [location, setLocation] = useState([]);
  const [workplaceType, setWorkplaceType] = useState([]);
  const [jobTypee, setJobTypee] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [applyFilterCount, setApplyFilterCount] = useState(0);
  const [employerJobDetails, setEmployerJobDetails] = useState([]);
  const [employerJobDetailsDupli, setEmployerJobDetailsDupli] = useState([]);
  const [employerJobType, setEmployerJobType] = useState([]);
  const [employerJobLocation, setEmployerJobLocation] = useState([]);
  const [employerJobSchedule, setEmployerJobSchedule] = useState([]);
  const [employerJobSector, setEmployerJobSector] = useState([]);
  const [employerJobSkill, setEmployerJobSkill] = useState([]);
  const [employerJobSpeci, setEmployerJobSpeci] = useState([]);
  const [employerJobWorkplace, setEmployerJobWorkplace] = useState([]);
  const [emplyerRecommended, setEmplyerRecommended] = useState([]);
  const [employerId, setEmployerId] = useState(0);
  const [employerSelectedJob, setEmployerSelectedJob] = useState(false);
  const [candidatesList, setCandidatesList] = useState([]);
  const [candidatesListDupli, setCandidatesListDupli] = useState([]);
  const [employerSelectedCardData, setEmployerSelectedCardData] = useState({
    job_status: '',

    additional_info: "",
    application_deadline_date: "",
    benefits: "",
    calendly_link: "",

    company_city: "",
    company_country: "",
    company_email: "",
    job_city: "",
    job_country: "",

    company_description: "",
    country: "",
    created_at: "",
    currency: "",
    custom_notes: "",
    duration: "",
    employer_id: 0,
    employer_type: "",
    id: 0,
    is_active: "",
    is_application_deadline: "",
    is_paid: "",
    job_desc: "",
    job_overview: "",
    job_title: "",
    job_type: "",
    profile_image: "",
    recommended_professional: [],
    required_background_check: "",
    required_cover_letter: "",
    required_resume: "",
    required_subcontract: "",
    responsibilities: "",
    sector: "",
    share_url: "",
    skills: "",
    state: "",
    time_commitment: "",
    specialisation: "",
    timezone: "",
    work_schedule: "",
    workplace_type: "",
    company_name: "",
    website_url: ""
  });
  const [recomSelectedCandidate, setRecomSelectedCandidate] = useState({
    city: "",
    country: "",
    first_name: "",
    job_title: "",
    last_name: "",
    professional_id: 0,
    profile_image: "",
    state: "",
  });
  const [superAdminEmployerSearch, setsuperAdminEmployerSearch] = useState('');

  // super admin employer
  const [jobGlow, setJobGlow] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobFullDetails, setJobFullDetails] = useState([]);
  const [jobsDuplicate, setJobsDuplicate] = useState([]);
  const [jobFilter, setJobFilter] = useState(false);
  const [selectedEmployer, setSelectedEmployer] = useState(false);
  const [employerApplyFilterCount, setEmployerApplyFilterCount] = useState(0);
  const [employerApplyFilterObject, setEmployerApplyFilterObject] = useState({});
  const [employerLocationConvertion, setEmployerLocationConvertion] = useState([]);
  const [professionalPlanConvertion, setprofessionalPlanConvertion] = useState([]);
  const [employerPlanConvertion, setEmployerPlanConvertion] = useState([]);
  const [employerSkillConvertion, setEmployerSkillConvertion] = useState([]);
  const [employerApplyFilterLoading, setEmployerApplyFilterLoading] = useState(false);
  const [employerFilterskills, setEmployerFilterskills] = useState([]);
  const [employerFilterplans, setEmployerFilterplans] = useState([]);
  const [employerFilterplanStatus, setEmployerFilterplanStatus] = useState([]);
  const [employerFilterloaction, setEmployerFilterLoaction] = useState([]);
  const [superAdminJobSearch, setsuperAdminJobSearch] = useState('')
  const [Jobplans, setJobplans] = useState([]);

  //Super Admin Partners 
  const [partnerFilterOpen, setPartnerFilterOpen] = useState(false);
  const [partnerGlow, setPartnerGlow] = useState(false);
  const [partnerCards, setPartnerCards] = useState([]);
  const [partnerCardsDupli, setPartnerCardsDupli] = useState([]);
  const [partnerFullDetails, setPartnerFullDetails] = useState([]);
  const [selectedPartnerAds, setSelectedPartnerAds] = useState([])
  const [partnerLocations, setPartnerLocations] = useState([]);
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [partnerPlans, setPartnerPlans] = useState([]);
  const [partnerSectors, setPartnerSectors] = useState([])
  const [partnerApplyFilterCount, setPartnerApplyFilterCount] = useState(0);
  const [selectedPartnerLoading, setSelectedPartnerLoading] = useState(false)
  const [partnerApplyFilterLoading, setPartnerApplyFilterLoading] = useState(false)
  const [partnerApplyFilterObject, setPartnerApplyFilterObject] = useState({});
  const [parType, setParType] = useState([]);
  const [parPlan, setParPlan] = useState([]);
  const [parLoc, setParLoc] = useState([]);
  const [parSector, setparSector] = useState([]);
  const [superAdminPartnerSearch, setsuperAdminPartnerSearch] = useState('');


  //All sort by sates
  const [professionalSortBy, setProfessionalSortBy] = useState('');
  const [employerSortBy, setEmployerSortBy] = useState('');
  const [jobsSortBy, setjobsSortBy] = useState('');
  const [partnerSortBy, setpartnerSortBy] = useState('');

  const [professionalGender, setProfessionalGender] = useState([]);
  const [professionalIndustrySector, setProfessionalIndustrySector] = useState([]);
  const [professionalJobType, setProfessionalJobType] = useState([]);
  const [professionalModeOfCommunication, setProfessionalModeOfCommunication] = useState([]);
  const [professionalSector, setProfessionalSector] = useState([]);
  const [professionalRelocate, setProfessionalRelocate] = useState([]);
  const [professionalLocPref, setProfessionalLocPref] = useState([]);
  const [professionalFunctionalSpeci, setProfessionalFunctionalSpeci] = useState([]);

  //super admin professional logics
  useEffect(() => {
    //finding minimum devices and updating to state at initial
    if (window.innerWidth <= 992) {
      setSmallDevice(true);
    } else {
      setSmallDevice(false);
    }

    //sidebar show or hide
    if (window.location.pathname === "/super_admin/professional/candidates_details") {
      setHideSideBar(true);
    } else {
      setHideSideBar(false);
    }

    //finding minimum devices and updating the state when screen adjustment
    const handleResize = () => {
      if (window.innerWidth <= 992) {
        setSmallDevice(true);
      } else {
        setSmallDevice(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getAdminDashboard = async (recall, pagination, sortbyparam) => {
    if (recall === undefined) {
      setsuperAdminProfessionalSearch('')
      setProfessionalPagination(true)
      setRecommendedProfiles([]);

      try {
        var obj = {
          professional_id: 0,
          page_number: pagination ? pagination + 1 : 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
        const res = await axiosInstance.post("/admin_professional_dashboard", obj);

        if (res.data.error_code === 0) {
          setProfessionalFilter(false);
          setPaginationTotalCount(res.data.data.total_count);
          var paginationPages = Math.ceil(res.data.data.total_count / pageRange);
          setPaginationpageCount(paginationPages);

          setProfessionalData(res.data.data);
          setProfessionalSelectedCardData(res.data.data);
          setProfessionalCards(res.data.data.canidates_description);
          setProfessionalCardsDupli(res.data.data.canidates_description);

          setRecommendedProfiles(res.data.data.recommended_jobs);
          setProfessionalKeepNotes(res.data.data.expert_notes);
          setProfessionalExpertNotes(res.data.data.expert_notes);
          setProfessionalAbout(res.data.data.about);
          setProfessionalPreferences(res.data.data.preferences);
          setProfessionalId(res.data.data.professional_id);
          setLanguage(res.data.data.languages);
          setSkills(res.data.data.skills);
          setVideo(res.data.data.video_name);
          setExperience(res.data.data.experience);
          setEducation(res.data.data.education);
          setAdditionalInfo(res.data.data.additional_info);
          setProfessionalPdf(res.data.data.resume_name);
          setProfessionalSocialLinks(res.data.data.social_link);

          if (res.data.data.filter_parameters.location.length > 0) {
            var professionalLocConvertion = res.data.data.filter_parameters.location.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalLocationConvertion(professionalLocConvertion);
          }

          if (res.data.data.filter_parameters.plan.length > 0) {
            var professionalPlanConvertion = res.data.data.filter_parameters.plan.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setprofessionalPlanConvertion(professionalPlanConvertion);
          }

          if (res.data.data.filter_parameters.skill.length > 0) {
            var orderingSkills = res.data.data.filter_parameters.skill.sort();
            var professionalSkillsConvertion = orderingSkills.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalSkillConvertion(professionalSkillsConvertion);
          }

          if (res.data.data.filter_parameters.gender.length > 0) {
            var professionalGenderConvertion = res.data.data.filter_parameters.gender.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalGender(professionalGenderConvertion);
          }

          if (res.data.data.filter_parameters?.industry_sector?.length) {
            var professionalindestrysectorConvertion = res.data.data.filter_parameters.industry_sector.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalIndustrySector(professionalindestrysectorConvertion);
          }

          if (res.data.data.filter_parameters.job_type.length > 0) {
            var professionalJobTypeConvertion = res.data.data.filter_parameters.job_type.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalJobType(professionalJobTypeConvertion);
          }

          if (res.data.data.filter_parameters.mode_of_communication.length > 0) {
            var professionalModeOfCommuniConvertion = res.data.data.filter_parameters.mode_of_communication.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalModeOfCommunication(professionalModeOfCommuniConvertion);
          }

          if (res.data.data.filter_parameters.sectors.length > 0) {
            var professionalsectorConvertion = res.data.data.filter_parameters.sectors.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalSector(professionalsectorConvertion);
          }

          if (res.data.data.filter_parameters.willing_to_relocate.length > 0) {
            var professionalRelocateConvertion = res.data.data.filter_parameters.willing_to_relocate.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalRelocate(professionalRelocateConvertion);
          }

          if (res.data.data.filter_parameters.work_location_preference.length > 0) {
            var professionalLocPreferConvertion = res.data.data.filter_parameters.work_location_preference.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalLocPref(professionalLocPreferConvertion);
          }

          if (res.data.data.filter_parameters.functional_specification.length > 0) {
            var professionalFunctionSpeciConvertion = res.data.data.filter_parameters.functional_specification.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setProfessionalFunctionalSpeci(professionalFunctionSpeciConvertion);
          }
          setProfessionalPagination(false)
          setInitialglow(false);
        } else {
          if (recall === "recall") {
            document.getElementById("closeExpertNotesApplyModal").click();
          }
          setInitialglow(false);
          setProfessionalPagination(false)
          setProfessionalCardsDupli([]);
          setExperience([]);
          setEducation([]);
          setSkills([]);
          setVideo("");
          setLanguage([]);
          setAdditionalInfo([]);
          setProfessionalId(0);
          setProfessionalPreferences("");
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      selectedData(professionalId, recall);
    }
  };

  const selectedData = async (cardId, recall) => {
    if (recall === undefined) {
      setRecommendedProfiles([]);
    }

    try {
      var obj = {
        professional_id: cardId,
      };

      const res = await axiosInstance.post("/individual_professional_detail", obj);

      if (res.data.error_code === 0) {
        if (recall === undefined) {
          setProfessionalData(res.data.data);
          setProfessionalSelectedCardData(res.data.data);

          setRecommendedProfiles(res.data.data.recommended_jobs);
          setProfessionalKeepNotes(res.data.data.expert_notes);
          setProfessionalExpertNotes(res.data.data.expert_notes);
          setProfessionalAbout(res.data.data.about);
          setProfessionalPreferences(res.data.data.preferences);
          setProfessionalId(res.data.data.professional_id);
          setLanguage(res.data.data.languages);
          setSkills(res.data.data.skills);
          setVideo(res.data.data.video_name);
          setExperience(res.data.data.experience);
          setEducation(res.data.data.education);
          setAdditionalInfo(res.data.data.additional_info);
          setProfessionalPdf(res.data.data.resume_name);
          setProfessionalSocialLinks(res.data.data.social_link);
        } else {
          var updateOriginalState = professionalCards.map((v) => {
            return v.professional_id === res.data.data.professional_id
              ? {
                ...v,
                expert_notes: res.data.data.expert_notes,
                recommended_jobs: res.data.data.recommended_jobs,
              }
              : v;
          });
          setProfessionalExpertNotes(res.data.data.expert_notes)
          setProfessionalCards(updateOriginalState);


          var updateState = professionalCardsDupli.map((v) => {
            return v.professional_id === res.data.data.professional_id
              ? {
                ...v,
                expert_notes: res.data.data.expert_notes,
                recommended_jobs: res.data.data.recommended_jobs,
              }
              : v;
          });
          setProfessionalCardsDupli(updateState);

          setRecommendedProfiles(res.data.data.recommended_jobs);
          switch (recall) {
            case "recall":
              setprofessionalClearNotes(false);
              setprofessionalSendNotes(false);
              document.getElementById("closeExpertNotesApplyModal").click();
              break;
            case "makeRecomrecall":
              document.getElementById("closeMakeRecBtn").click();
              setDeletingCardId(0);
              setprofessionalMakeRecommendation(false);
              break;

            default:
              break;
          }
        }
      }
      setSelectedCard(false);

    } catch (err) {
      console.log(err);
    }
  };

  const handleProfessionalupdateNotes = async (executionType) => {
    try {
      if (executionType === "send") {
        var obj = {
          expert_notes: professionalkeepNotes,
          professional_id: professionalData.professional_id,
          is_clear: "N"
        };
      } else {
        var obj = {
          expert_notes: "",
          professional_id: professionalData.professional_id,
          is_clear: "Y"
        };

      }

      if (executionType === "send")
        if (professionalkeepNotes !== "") {
          setprofessionalSendNotes(true)
          const res = await axiosInstance.post("/send_expert_notes", obj);
          if (res.data.error_code === 0) {
            if (professionalApplyFilterCount === 0) {
              getAdminDashboard("recall");
            } else {
              handleAdminProfessionalMeilisearch(professionalApplyFilterObject, "recall")
            }
          } else {
            setprofessionalSendNotes(false)
          }
        }
        else {
          toast.error("please fill in all fields")
        }

      if (executionType === "clear") {
        if (professionalkeepNotes !== "") {
          setprofessionalClearNotes(true)
          const res = await axiosInstance.post("/send_expert_notes", obj);
          if (res.data.error_code === 0) {
            if (professionalApplyFilterCount === 0) {
              getAdminDashboard("recall");
              setProfessionalKeepNotes("")
            } else {
              handleAdminProfessionalMeilisearch(professionalApplyFilterObject, "recall")
            }
          } else {
            setprofessionalClearNotes(false)
          }
        } else {
          toast.error("nothing to clear")
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleProfessionalGetCompany = async (profesId) => {
    setMakeRecommendationLoading(true);
    try {
      var obj = {
        professional_id: profesId
      }

      const res = await axiosInstance.post("/get_company_names", obj);

      if (res.data.error_code === 0) {
        setRecCompanyList(res.data.data);
        setMakeRecommendationLoading(false);
      } else {
        setRecCompanyList([]);
        setMakeRecommendationLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAdminProfessionalMeilisearch = async (params, recall, pagination) => {
    var obj = {}
    setProfessionalPagination(true);
    if (recall === undefined) {
      setRecommendedProfiles([]);
    }

    if (pagination === undefined) {
      obj = {
        ...params,
        page_number: 1,
      };
    } else {
      obj = {
        ...params,
        page_number: pagination + 1,
      };
    }

    try {
      // admin_professional_filter_results
      let endpoint = professionalSearchType === 'Text search' ? "/admin_professional_filter_results" : "/admin_professional_meilisearch"
      if (professionalSearchType !== 'Text search' && obj.page_number > 1) obj.pagination_flag = "first_page"

      setProfessionalApplyFilterObject(obj)
      const { data } = await axiosInstance.post(endpoint, obj)

      if (data.error_code === 0) {
        if (recall === undefined) {
          if (data.data.professional_id !== undefined) {
            setPaginationTotalCount(data.data.total_count);
            var paginationPages = Math.ceil(data.data.total_count / pageRange);
            setPaginationpageCount(paginationPages);

            setProfessionalData(data.data);
            setProfessionalSelectedCardData(data.data);
            setProfessionalCards(data.data.professional_details);
            setProfessionalCardsDupli(data.data.professional_details);

            setRecommendedProfiles(data.data.professional_details[0].recommended_jobs);
            setProfessionalKeepNotes(data.data.expert_notes);
            setProfessionalExpertNotes(data.data.expert_notes);
            setProfessionalAbout(data.data.about);
            setProfessionalPreferences(data.data.preferences);
            setProfessionalId(data.data.professional_id);
            setLanguage(data.data.languages);
            setSkills(data.data.skills);
            setVideo(data.data.video_name);
            setExperience(data.data.experience);
            setEducation(data.data.education);
            setAdditionalInfo(data.data.additional_info);
            setProfessionalPdf(data.data.resume_name);
            setProfessionalSocialLinks(data.data.social_link);
          } else {
            setProfessionalCardsDupli([]);
            setProfessionalSelectedCardData({});
            setExperience([]);
            setEducation([]);
            setSkills([]);
            setVideo("");
            setLanguage([]);
            setAdditionalInfo([]);
            setProfessionalId(0);
            setProfessionalPreferences("");

          }
        } else {
          selectedData(professionalId, recall);
        }
      } else {
        if (recall === "recall") {
          document.getElementById("closeExpertNotesApplyModal").click();
        }
        setProfessionalCardsDupli([]);
        setProfessionalSelectedCardData({})
        setExperience([]);
        setEducation([]);
        setSkills([]);
        setVideo("");
        setLanguage([]);
        setAdditionalInfo([]);
        setProfessionalId(0);
        setProfessionalPreferences("");
      }
      setProfessionalPagination(false);
      setProfessionalFilter(false);
    }
    catch (Err) {
      setProfessionalSelectedCardData({})
      setExperience([]);
      setEducation([]);
      setSkills([]);
      setVideo("");
      setLanguage([]);
      setAdditionalInfo([]);
      setProfessionalId(0);
      setProfessionalPreferences("");
      setProfessionalPagination(false);
      setProfessionalFilter(false);
    }
  }
  //

  //super admin employer logics
  const getEmployerDashboard = async (recall, pagination, sortbyparam) => {
    setEmployerApplyFilterLoading(true)
    setsuperAdminEmployerSearch('');
    try {
      if (pagination === undefined) {
        var obj = {
          employer_id: 0,
          page_number: 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      } else {
        var obj = {
          employer_id: 0,
          page_number: pagination + 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      }

      const res = await axiosInstance.post("/admin_employer_dashboard", obj);
      if (res.data.error_code === 0) {
        if (recall === undefined) {
          setEmployerOpen(false);

          if (res.data.data[0].filter_parameters.location.length > 0) {
            var professionalLocConvertion =
              res.data.data[0].filter_parameters.location.map((v, i) => {
                return { value: i + 1, label: v, disabled: false };
              });
            setEmployerLocationConvertion(professionalLocConvertion);
          }

          if (res.data.data[0].filter_parameters.plan.length > 0) {
            var professionalPlanConvertion =
              res.data.data[0].filter_parameters.plan.map((v, i) => {
                return { value: v, label: v, disabled: false };
              });

            professionalPlanConvertion.unshift({ value: 'Free trial', label: 'Free trial', disabled: false })
            professionalPlanConvertion.unshift({ value: 'Unpaid users', label: 'Unpaid users', disabled: false })
            setEmployerPlanConvertion(professionalPlanConvertion);
          }

          if (res.data.data[0].filter_parameters.sector.length > 0) {
            var professionalSectorConvertion = res.data.data[0].filter_parameters.sector.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setEmployerSkillConvertion(professionalSectorConvertion);
          }

          setPaginationTotalCount(res.data.data[0].total_count);
          var paginationPages = Math.ceil(res.data.data[0].total_count / pageRange);
          setPaginationpageCount(paginationPages);

          setJobs(res.data.data[0].employee_short_desc)
          setJobsDuplicate(res.data.data[0].employee_short_desc)
          setJobFullDetails(res.data.data[0].first_employee_details[0])
          setJobEmployerTotalJobsDetails(res.data.data[0].first_employee_details[0]?.posted_job_details || [])
        }
      }
      setJobGlow(false);
      setEmployerApplyFilterLoading(false)
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleIndividualEmployerCard = async (id) => {
    setSelectedEmployer(true);
    setemployerJobsSortBy("All")

    try {
      if (smallDevice) {
        pageRender("/super_admin/employer/employer_details")
      }
      const obj = {
        user_id: id
      }
      const res = await axiosInstance.post("/individual_employer_detail", obj)

      if (res.data.error_code === 0) {
        setJobEmployerTotalJobsDetails(res.data.data[0].employee_short_desc[0]?.posted_job_details || [])
        setJobFullDetails(res.data.data[0].employee_short_desc[0] || []);
      }
      setSelectedEmployer(false)
    }
    catch (err) {
      console.log(err)
    }
  }

  const initializeEmployerReset = () => {
    setIsMilleSearchFiltered(false)
    setEmployerApplyFilterLoading(true)
    setEmployerFilterskills([])
    setEmployerFilterplans([])
    setEmployerFilterLoaction([])
    setJobs([])
    setJobFullDetails({})
    setJobsDuplicate([])
    setEmployerFilterplanStatus([])
    setEmployerApplyFilterObject({})

    setEmployerApplyFilterCount(0)
  }

  const handleAdminEmployerlMeilisearch = async (object, pagination) => {
    setEmployerApplyFilterLoading(true)
    if (pagination === undefined) {
      var obj = {
        ...object,
        page_number: 1,
      };
    } else {
      var obj = {
        ...object,
        page_number: pagination + 1,
      };
    }

    try {
      const res = await axiosInstance.post("/admin_employer_meilisearch", obj);
      if (res.data.error_code === 0) {
        setPaginationTotalCount(res.data.data[0].total_count);

        var paginationPages = Math.ceil(res.data.data[0].total_count / pageRange);
        setPaginationpageCount(paginationPages);

        setJobs(res.data.data[0].employee_short_desc)
        setJobsDuplicate(res.data.data[0].employee_short_desc)
        setJobFullDetails(res.data.data[0].first_employee_details[0])
        setJobEmployerTotalJobsDetails(res.data.data[0].employee_short_desc[0]?.posted_job_details || [])
      } else {
        setJobs([])
        setJobsDuplicate([])
        setJobFullDetails({})
      }
      setEmployerApplyFilterLoading(false);
      setEmployerOpen(false)
    } catch (err) {
      console.log(err)
    }
  }
  //

  //super admin job logics
  const initializeReset = () => {
    setSkillss([]);
    setSectors([]);
    setSpecialization([]);
    setWorkplaceType([]);
    setJobTypee([]);
    setSchedule([]);
    setMellieSearchJobPlans([]);
    setJobStatusSelect([])

    var rmv = document.querySelectorAll("input[type=checkbox]");
    for (var i = 0; i < rmv.length; i++) {
      rmv[i].checked = false;
    }

    setApplyFilterCount(0);
    setjobApplyFilterObject({});
    setEmployerOpen(false);
    setIsMilleSearchFiltered(false)
    setemployerJobsSortBy("All")
  };

  const getJobDashboard = async (recall, pagination, sortbyparam, jobIdByUrl) => {
    setJobApplyFilterLoading(true);
    setsuperAdminJobSearch('')
    setemployerJobsSortBy("All")

    try {
      if (pagination === undefined) {
        var obj = {
          job_id: 0,
          page_number: 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      } else {
        var obj = {
          job_id: 0,
          page_number: pagination + 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      }

      const res = await axiosInstance.post("/admin_jobs_dashboard", obj);

      if (res.data.error_code === 0) {
        if (recall === undefined) {
          setEmployerOpen(false);
          setPaginationTotalCount(res.data.data.total_count);
          var paginationPages = Math.ceil(res.data.data.total_count / pageRange);
          setPaginationpageCount(paginationPages);
          setEmployerJobDetails(res.data.data.job_details);
          setEmployerJobDetailsDupli(res.data.data.job_details);
          setEmployerJobType(res.data.data.job_type);

          if (res.data.data.location.length > 0) {
            var locationConvertion = res.data.data.location.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setEmployerJobLocation(locationConvertion);
          }

          setEmployerJobSchedule(res.data.data.schedule);

          if (res.data.data.sector.length > 0) {
            var sectorConvertion = res.data.data.sector.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setEmployerJobSector(sectorConvertion);
          }

          if (res.data.data.skill.length > 0) {
            var orderingemployerSkills = res.data.data.skill.sort();

            var skillConvertion = orderingemployerSkills.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });

            setEmployerJobSkill(skillConvertion);
          }

          if (res.data.data.plan.length > 0) {
            var orderingJobPlans = res.data.data.plan.sort();

            var planConvertion = orderingJobPlans.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });

            setJobplans(planConvertion);
          }

          if (res.data.data.specialisation.length > 0) {
            var specialisationConvertion = res.data.data.specialisation.map(
              (v, i) => {
                return { value: i + 1, label: v, disabled: false };
              }
            );
            setEmployerJobSpeci(specialisationConvertion);
          }

          setEmployerJobWorkplace(res.data.data.workplace_type);
          if (jobIdByUrl === undefined) {
            if (res.data.data.job_details.length > 0) {
              setEmployerSkills(res.data.data.job_details[0].skills.split(','))
              setEmployerId(res.data.data.job_details[0].id);
              setEmplyerRecommended(res.data.data.job_details[0].recommended_professional);
              setEmployerTakeNotes(res.data.data.job_details[0].custom_notes);
              setEmployerSelectedCardData({
                ...employerSelectedCardData,
                job_status: res.data.data.job_details[0].job_status,
                company_city: res.data.data.job_details[0].company_city,
                company_country: res.data.data.job_details[0].company_country,
                company_email: res.data.data.job_details[0].company_email,
                job_city: res.data.data.job_details[0].job_city,
                job_country: res.data.data.job_details[0].job_country,
                company_name: res.data.data.job_details[0].company_name,
                website_url: res.data.data.job_details[0].website_url,
                additional_info: res.data.data.job_details[0].additional_info,
                application_deadline_date: res.data.data.job_details[0].application_deadline_date,
                benefits: res.data.data.job_details[0].benefits,
                calendly_link: res.data.data.job_details[0].calendly_link,
                city: res.data.data.job_details[0].city,
                custom_notes: res.data.data.job_details[0].custom_notes,
                company_description: res.data.data.job_details[0].company_description,
                country: res.data.data.job_details[0].country,
                created_at: res.data.data.job_details[0].created_at,
                currency: res.data.data.job_details[0].currency,
                duration: res.data.data.job_details[0].duration,
                employer_id: res.data.data.job_details[0].employer_id,
                employer_type: res.data.data.job_details[0].employer_type,
                id: res.data.data.job_details[0].id,
                job_share_link: `${process.env.REACT_APP_SHARE_BASEURL}/professional/all_jobs?job_id=${encryptData(res.data.data.job_details[0].id)}`,
                is_active: res.data.data.job_details[0].is_active,
                is_application_deadline: res.data.data.job_details[0].is_application_deadline,
                is_paid: res.data.data.job_details[0].is_paid,
                job_desc: res.data.data.job_details[0].job_desc,
                job_overview: res.data.data.job_details[0].job_overview,
                job_title: res.data.data.job_details[0].job_title,
                job_type: res.data.data.job_details[0].job_type,
                profile_image: res.data.data.job_details[0].profile_image,
                payment_status: res.data.data.job_details[0].payment_status,
                pricing_category: res.data.data.job_details[0].pricing_category,
                recommended_professional: res.data.data.job_details[0].recommended_professional,
                required_background_check: res.data.data.job_details[0].required_background_check,
                required_cover_letter: res.data.data.job_details[0].required_cover_letter,
                required_resume: res.data.data.job_details[0].required_resume,
                required_subcontract: res.data.data.job_details[0].required_subcontract,
                responsibilities: res.data.data.job_details[0].responsibilities,
                sector: res.data.data.job_details[0].sector,
                specialisation: res.data.data.job_details[0].specialisation,
                share_url: res.data.data.job_details[0].share_url,
                skills: res.data.data.job_details[0].skills,
                state: res.data.data.job_details[0].state,
                time_commitment: res.data.data.job_details[0].time_commitment,
                timezone: res.data.data.job_details[0].timezone,
                work_schedule: res.data.data.job_details[0].work_schedule,
                workplace_type: res.data.data.job_details[0].workplace_type,
              });
            }
          }
        } else {
          selectedJobCard(employerSelectedCardData.id, recall);
        }
      }
      setInitialglow(false);
      setJobApplyFilterLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const selectedJobCard = async (id, recall) => {
    setemployerJobsSortBy("All")

    if (recall === undefined) {
      setEmployerSelectedJob(true);
    }

    try {
      var obj = {
        job_id: id,
      };

      const res = await axiosInstance.post("/individual_job_detail", obj);

      if (res.data.error_code === 0) {

        if (res.data.data.length > 0) {
          if (recall === undefined) {
            setEmployerId(res.data.data[0].id);
            setEmplyerRecommended(res.data.data[0].recommended_professionals);
            setEmployerSkills(res.data.data[0].skills.split(','))
            setEmployerSelectedCardData({
              ...employerSelectedCardData,
              job_status: res.data.data[0].job_status,
              company_city: res.data.data[0].company_city,
              company_country: res.data.data[0].company_country,
              company_email: res.data.data[0].company_email,
              job_city: res.data.data[0].job_city,
              job_country: res.data.data[0].job_country,
              company_name: res.data.data[0].company_name,
              website_url: res.data.data[0].website_url,
              additional_info: res.data.data[0].additional_info,
              application_deadline_date: res.data.data[0].application_deadline_date,
              benefits: res.data.data[0].benefits,
              calendly_link: res.data.data[0].calendly_link,
              company_description: res.data.data[0].company_description,
              custom_notes: res.data.data[0].custom_notes,
              created_at: res.data.data[0].created_at,
              currency: res.data.data[0].currency,
              duration: res.data.data[0].duration,
              employer_id: res.data.data[0].employer_id,
              employer_type: res.data.data[0].employer_type,
              id: res.data.data[0].id,
              job_share_link: `${process.env.REACT_APP_SHARE_BASEURL}/professional/all_jobs?job_id=${encryptData(res.data.data[0].id)}`,
              is_active: res.data.data[0].is_active,
              is_application_deadline: res.data.data[0].is_application_deadline,
              is_paid: res.data.data[0].is_paid,
              job_desc: res.data.data[0].job_desc,
              job_overview: res.data.data[0].job_overview,
              job_title: res.data.data[0].job_title,
              job_type: res.data.data[0].job_type,
              profile_image: res.data.data[0].profile_image,
              payment_status: res.data.data[0].payment_status,
              pricing_category: res.data.data[0].pricing_category,
              recommended_professional: res.data.data[0].recommended_professional,
              required_background_check: res.data.data[0].required_background_check,
              required_cover_letter: res.data.data[0].required_cover_letter,
              required_resume: res.data.data[0].required_resume,
              required_subcontract: res.data.data[0].required_subcontract,
              responsibilities: res.data.data[0].responsibilities,
              sector: res.data.data[0].sector,
              specialisation: res.data.data[0].specialisation,
              share_url: res.data.data[0].share_url,
              skills: res.data.data[0].skills,
              state: res.data.data[0].state,
              time_commitment: res.data.data[0].time_commitment,
              timezone: res.data.data[0].timezone,
              work_schedule: res.data.data[0].work_schedule,
              workplace_type: res.data.data[0].workplace_type,
            });
            setEmployerTakeNotes(res.data.data[0]?.custom_notes);

          } else {
            var updateOriginalState = employerJobDetails.map((v) => {
              return v.id === res.data.data[0].id
                ? {
                  ...v,
                  custom_notes: res.data.data[0].custom_notes,
                  recommended_professional: res.data.data[0].recommended_professionals,
                }
                : v;
            });
            setEmployerJobDetails(updateOriginalState);

            setEmployerTakeNotes(res.data.data[0]?.custom_notes);

            var updateState = employerJobDetailsDupli.map((v) => {
              return v.id === res.data.data[0].id
                ? {
                  ...v,
                  custom_notes: res.data.data[0].custom_notes,
                  recommended_professional:
                    res.data.data[0].recommended_professionals,
                }
                : v;
            });
            setEmployerJobDetailsDupli(updateState);

            setEmployerSelectedCardData({ ...employerSelectedCardData, custom_notes: res.data.data[0]?.custom_notes })

            setEmplyerRecommended(res.data.data[0].recommended_professionals);

            switch (recall) {
              case "recall":
                setemployerSavingNotes(false);
                setEmployerClearNotes(false);
                document.getElementById("closeEmpTakeNotes").click();
                break;
              case "makeRecomrecall":
                setjobMakeRecommendation(false);
                document.getElementById("closeEmpMakeRecBtn").click();
                setDeletingCardId(0);
                break;

              default:
                break;
            }
          }
        }
      }
      setEmployerSelectedJob(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getJobList = async () => {
    setjobCandidateListResponse(true);
    try {
      setRecomSelectedCandidate({
        city: "",
        country: "",
        first_name: "",
        job_title: "",
        last_name: "",
        professional_id: 0,
        profile_image: "",
        state: "",
      });

      var obj = {
        job_id: employerSelectedCardData.id,
      };

      const res = await axiosInstance.post("/get_professional_details", obj);
      if (res.data.error_code === 0) {
        if (res.data.data.length > 0) {
          setCandidatesList(res.data.data);
          setCandidatesListDupli(res.data.data);
        } else {
          setCandidatesList([]);
          setCandidatesListDupli([]);
        }
      } else {
        setCandidatesList([]);
        setCandidatesListDupli([]);
      }

      setjobCandidateListResponse(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRecommendationProfileSearch = async (params) => {
    setjobCandidateListResponse(true);
    try {
      const res = await axiosInstance.post("/admin_make_recommendation_search", params);
      if (res.data.error_code === 0) {
        if (res.data.data.length > 0) {
          setCandidatesList(res.data.data);
          setCandidatesListDupli(res.data.data);
        } else {
          setCandidatesList([]);
          setCandidatesListDupli([]);
        }
      } else {
        setCandidatesList([]);
        setCandidatesListDupli([]);
      }

      setjobCandidateListResponse(false);

    } catch (Err) {
      console.log(Err);
    }
  }

  const handleAdminJobslMeilisearch = async (object, pagination) => {
    setJobApplyFilterLoading(true);

    if (pagination === undefined) {
      var obj = {
        ...object,
        page_number: 1,
      };
    } else {
      var obj = {
        ...object,
        page_number: pagination + 1,
      };
    }

    try {
      const res = await axiosInstance.post("/admin_jobs_meilisearch", obj);
      if (res.data.error_code === 0) {
        if (res.data.data.job_details !== undefined) {
          setPaginationTotalCount(res.data.data.total_count);
          var paginationPages = Math.ceil(res.data.data.total_count / pageRange);
          setPaginationpageCount(paginationPages);

          setEmployerJobDetails(res.data.data.job_details);
          setEmployerJobDetailsDupli(res.data.data.job_details);
          setEmployerId(res.data.data.job_details[0].id);
          setEmplyerRecommended(res.data.data.job_details[0].recommended_professional);
          setEmployerTakeNotes(res.data.data.job_details[0].custom_notes);
          setEmployerSelectedCardData({
            ...employerSelectedCardData,
            job_status: res.data.data.job_details[0].job_status,
            company_city: res.data.data.job_details[0].company_city,
            company_country: res.data.data.job_details[0].company_country,
            company_email: res.data.data.job_details[0].company_email,
            job_city: res.data.data.job_details[0].job_city,
            job_country: res.data.data.job_details[0].job_country,
            company_name: res.data.data.job_details[0].company_name,
            website_url: res.data.data.job_details[0].website_url,
            additional_info: res.data.data.job_details[0].additional_info,
            application_deadline_date: res.data.data.job_details[0].application_deadline_date,
            benefits: res.data.data.job_details[0].benefits,
            calendly_link: res.data.data.job_details[0].calendly_link,
            custom_notes: res.data.data.job_details[0].custom_notes,
            company_description: res.data.data.job_details[0].company_description,
            created_at: res.data.data.job_details[0].created_at,
            currency: res.data.data.job_details[0].currency,
            duration: res.data.data.job_details[0].duration,
            employer_id: res.data.data.job_details[0].employer_id,
            employer_type: res.data.data.job_details[0].employer_type,
            id: res.data.data.job_details[0].id,
            job_share_link: `${process.env.REACT_APP_SHARE_BASEURL}/professional/all_jobs?job_id=${encryptData(res.data.data.job_details[0].id)}`,
            is_active: res.data.data.job_details[0].is_active,
            is_application_deadline: res.data.data.job_details[0].is_application_deadline,
            is_paid: res.data.data.job_details[0].is_paid,
            job_desc: res.data.data.job_details[0].job_desc,
            job_overview: res.data.data.job_details[0].job_overview,
            job_title: res.data.data.job_details[0].job_title,
            job_type: res.data.data.job_details[0].job_type,
            profile_image: res.data.data.job_details[0].profile_image,
            payment_status: res.data.data.job_details[0].payment_status,
            pricing_category: res.data.data.job_details[0].pricing_category,
            recommended_professional: res.data.data.job_details[0].recommended_professional,
            required_background_check: res.data.data.job_details[0].required_background_check,
            required_cover_letter: res.data.data.job_details[0].required_cover_letter,
            required_resume: res.data.data.job_details[0].required_resume,
            required_subcontract: res.data.data.job_details[0].required_subcontract,
            responsibilities: res.data.data.job_details[0].responsibilities,
            sector: res.data.data.job_details[0].sector,
            share_url: res.data.data.job_details[0].share_url,
            skills: res.data.data.job_details[0].skills,
            state: res.data.data.job_details[0].state,
            time_commitment: res.data.data.job_details[0].time_commitment,
            timezone: res.data.data.job_details[0].timezone,
            work_schedule: res.data.data.job_details[0].work_schedule,
            workplace_type: res.data.data.job_details[0].workplace_type,
          });
        } else {
          setPaginationTotalCount(0)
          setEmployerJobDetails([])
          setEmployerJobDetailsDupli([])
          setEmplyerRecommended([])
          setEmployerSelectedCardData({
            job_status: "",
            company_city: "",
            company_country: "",
            company_email: "",
            job_city: "",
            job_country: "",
            additional_info: "",
            application_deadline_date: "",
            benefits: "",
            calendly_link: "",
            company_description: "",
            created_at: "",
            currency: "",
            custom_notes: "",
            duration: "",
            employer_id: 0,
            employer_type: "",
            id: 0,
            is_active: "",
            is_application_deadline: "",
            is_paid: "",
            job_desc: "",
            job_overview: "",
            job_title: "",
            job_type: "",
            profile_image: "",
            recommended_professional: [],
            required_background_check: "",
            required_cover_letter: "",
            required_resume: "",
            required_subcontract: "",
            responsibilities: "",
            sector: "",
            share_url: "",
            skills: "",
            state: "",
            time_commitment: "",
            timezone: "",
            work_schedule: "",
            workplace_type: "",
          })
        }
      } else {
        setEmployerJobDetails([])
        setEmployerJobDetailsDupli([])
        setEmplyerRecommended([])
        setEmployerSelectedCardData({
          job_status: "",
          company_city: "",
          company_country: "",
          company_email: "",
          job_city: "",
          job_country: "",
          additional_info: "",
          application_deadline_date: "",
          benefits: "",
          calendly_link: "",
          company_description: "",
          created_at: "",
          currency: "",
          custom_notes: "",
          duration: "",
          employer_id: 0,
          employer_type: "",
          id: 0,
          is_active: "",
          is_application_deadline: "",
          is_paid: "",
          job_desc: "",
          job_overview: "",
          job_title: "",
          job_type: "",
          profile_image: "",
          recommended_professional: [],
          required_background_check: "",
          required_cover_letter: "",
          required_resume: "",
          required_subcontract: "",
          responsibilities: "",
          sector: "",
          share_url: "",
          skills: "",
          state: "",
          time_commitment: "",
          timezone: "",
          work_schedule: "",
          workplace_type: "",
        })
      }
      setJobApplyFilterLoading(false);
      setEmployerOpen(false)
    } catch (err) {
      console.log(err)
    }
  }

  //super admin partner 
  const getPartnerDashboard = async (recall, pagination, sortbyparam) => {
    setPartnerApplyFilterLoading(true);
    setsuperAdminPartnerSearch('');

    try {
      if (pagination === undefined) {
        var obj = {
          partner_id: 0,
          page_number: 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      } else {
        var obj = {
          partner_id: 0,
          page_number: pagination + 1,
          key: sortbyparam ? "sort" : '',
          param: sortbyparam ? sortbyparam : ''
        };
      }

      const res = await axiosInstance.post("/admin_partner_dashboard", obj);
      if (recall === undefined) {
        setPartnerGlow(false);

        setPaginationTotalCount(res.data.data[0].total_count);
        var paginationPages = Math.ceil(res.data.data[0].total_count / pageRange);
        setPaginationpageCount(paginationPages);

        setPartnerCards(res.data.data[0].partner_short_desc)
        setPartnerCardsDupli(res.data.data[0].partner_short_desc)
        setPartnerFullDetails(res.data.data[0].first_partner_details)
        setSelectedPartnerAds(res.data.data[0].first_partner_posts)

        if (res.data.data[0].filter_parameters.sector) {
          var partnerSectorConvertion = res.data.data[0].filter_parameters.sector.map((v, i) => {
            return { value: i + 1, label: v, disabled: false };
          });
          setPartnerSectors(partnerSectorConvertion);
        }

        if (res.data.data[0].filter_parameters.location) {
          var partnerLocationConvertion = res.data.data[0].filter_parameters.location.map((v, i) => {
            return { value: i + 1, label: v, disabled: false };
          });
          setPartnerLocations(partnerLocationConvertion);
        }

        if (res.data.data[0].filter_parameters.partner_type) {
          var partnerTypeConvertion = res.data.data[0].filter_parameters.partner_type.map((v, i) => {
            return { value: i + 1, label: v, disabled: false };
          });
          setPartnerTypes(partnerTypeConvertion);
        }

        if (res.data.data[0].filter_parameters.plan) {
          var partnerPlanConvertion = res.data.data[0].filter_parameters.plan.map((v, i) => {
            return { value: i + 1, label: v, disabled: false };
          });
          setPartnerPlans(partnerPlanConvertion);
        }
      } else {
        selectedPartnerCard(partnerFullDetails?.id, recall);
      }
      setPartnerFilterOpen(false);
      setPartnerApplyFilterLoading(false);
    } catch (err) {
      console.log(err)
    }
  }

  const selectedPartnerCard = async (partner_user_id) => {
    setSelectedPartnerLoading(true)
    try {
      const obj = {
        user_id: partner_user_id
      }
      const res = await axiosInstance.post("/individual_partner_detail", obj)

      if (res.data.error_code === 0) {
        if (res.data.data.length > 0) {
          setPartnerFullDetails(res.data.data[0].partner_short_desc)
          setSelectedPartnerAds(res.data.data[0].partner_learning_posts)
        } else {
          setPartnerFullDetails([])
          setSelectedPartnerAds([])
        }
      }
      setSelectedPartnerLoading(false)
    }
    catch (err) {
      console.log(err)
    }
  }

  const initializePartnerReset = () => {
    setPartnerFilterOpen(false);
    setPartnerApplyFilterCount(0);
    setParType([])
    setParPlan([])
    setParLoc([])
    setparSector([])
    setPartnerApplyFilterObject({});
    setIsMilleSearchFiltered(false)
  };

  const handleAdminPartnerMeilisearch = async (object, pagination) => {
    setPartnerApplyFilterLoading(true);

    if (pagination === undefined) {
      var obj = {
        ...object,
        page_number: 1,
      };
    } else {
      var obj = {
        ...object,
        page_number: pagination + 1,
      };
    }

    try {
      const res = await axiosInstance.post("/admin_partner_meilisearch", obj);

      if (res.data.error_code === 0) {
        setPaginationTotalCount(res.data.data[0].total_count);
        var paginationPages = Math.ceil(res.data.data[0].total_count / pageRange);
        setPaginationpageCount(paginationPages);

        setPartnerCards(res.data.data[0].partner_short_desc)
        setPartnerCardsDupli(res.data.data[0].partner_short_desc)

        setPartnerFullDetails(res.data.data[0].first_partner_details)
        setSelectedPartnerAds(res.data.data[0].first_partner_posts)

        setPartnerApplyFilterLoading(false);
        setPartnerFilterOpen(false);
      }
      else {
        setSelectedPartnerAds([])
        setPartnerCards([])
        setPartnerCardsDupli([])
        setPartnerFullDetails([])
        setPartnerApplyFilterLoading(false);
        setPartnerFilterOpen(false);
      }
      setPartnerApplyFilterLoading(false);
      setEmployerOpen(false)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <SuperAdminContext.Provider
      value={{
        deletionContent,
        setDeletionContent,
        deleteRecommendationId,
        setDeleteRecommendationId,
        employerTabSwitching,
        setemployerTabSwitching,
        employerJobsSortBy,
        setemployerJobsSortBy,
        employerTotalJobsDetails,
        setJobEmployerTotalJobsDetails,
        professionalGender, setProfessionalGender,
        professionalIndustrySector, setProfessionalIndustrySector, handleRecommendationProfileSearch,
        professionalJobType, setProfessionalJobType,
        professionalModeOfCommunication, setProfessionalModeOfCommunication,
        professionalSector, setProfessionalSector,
        professionalRelocate, setProfessionalRelocate,
        professionalLocPref, setProfessionalLocPref,
        professionalFunctionalSpeci, setProfessionalFunctionalSpeci,
        professionalSearchType, setProfessionalSearchType,
        hidesidebar, setHideSideBar, minimumDeviceCards, setMinimumDeviceCards,
        initialGlow, setInitialglow, experience, setExperience,
        education, setEducation, skills, setSkills, video, setVideo,
        language, setLanguage, professionalLocationConvertion, professionalSkillConvertion,
        setProfessionalLocationConvertion, setProfessionalSkillConvertion,
        additionalInfo, setAdditionalInfo, employerSkills, setEmployerSkills, smallDevice, getAdminDashboard,
        professionalData, professionalId, professionalCards, professionalSelectedCardData,
        professionalAbout, professionalPreferences, professionalPdf, professionalSocialLinks,
        selectedData, selectedcard, professionalCardsDupli, setProfessionalCardsDupli,
        professionalExpertNotes, professionalkeepNotes, setProfessionalKeepNotes, setSelectedCard,
        handleProfessionalupdateNotes, handleProfessionalGetCompany, makeRecommendationLoading, setMakeRecommendationLoading,
        recCompanyList, setRecCompanyList,
        recommendedProfiles, deletingCardId,
        setDeletingCardId, setRecommendedProfiles,
        professionalApplyFilterCount, setProfessionalApplyFilterCount,
        professionalApplyFilterObject,
        setProfessionalApplyFilterObject,
        professionalSearch, setProfessionalSearch,
        professionalFilter, setProfessionalFilter,
        professionalPlanConvertion, setprofessionalPlanConvertion,
        professionalPagination, profmellieSearchSkills,
        setProfMellieSearchSkills, profmellieSearchLocations,
        setProfMellieSearchLocations, profmellieSearchPlans,
        setProfMellieSearchPlans, superAdminProfessionalSearch,
        setsuperAdminProfessionalSearch,
        professionalSortBy, setProfessionalSortBy,
        employerSortBy, setEmployerSortBy,
        jobsSortBy, setjobsSortBy,
        partnerSortBy, setpartnerSortBy,
        isMilleSearchFiltered, setIsMilleSearchFiltered,

        isSearched, setIsSearched,

        paginationpageCount,
        currentPage,
        setCurrentPage,
        paginationTotalCount,
        setPaginationTotalCount,

        employerTakeNotes,
        setEmployerTakeNotes,
        employerOpen,
        setEmployerOpen,
        initializeReset,
        jobCandidateListResponse,
        jobApplyFilterLoading,
        setJobApplyFilterLoading,
        skillss,
        setSkillss,
        sectors,
        setSectors,
        specialization,
        setSpecialization,
        workplaceType,
        setWorkplaceType,
        jobTypee,
        setJobTypee,
        schedule,
        setSchedule,
        jobApplyFilterObject,
        setjobApplyFilterObject,
        getJobDashboard,
        applyFilterCount,
        setApplyFilterCount,
        employerJobDetails,
        employerJobDetailsDupli,
        setEmployerJobDetailsDupli,
        employerJobType,
        employerJobLocation,
        employerJobSchedule,
        employerJobSector,
        employerJobSkill,
        employerJobSpeci,
        setEmployerJobLocation,
        setEmployerJobSector,
        setEmployerJobSkill,
        setEmployerJobSpeci,
        employerJobWorkplace,
        emplyerRecommended,
        employerSelectedCardData,
        employerSelectedJob,
        recomSelectedCandidate,
        setRecomSelectedCandidate,
        candidatesList,
        candidatesListDupli,
        setCandidatesListDupli,
        employerId,
        setEmployerId,
        selectedJobCard,
        getJobList,
        setEmployerSelectedCardData,
        superAdminEmployerSearch, setsuperAdminEmployerSearch,

        professionalClearNotes, setprofessionalClearNotes,
        professionalSendNotes, setprofessionalSendNotes,
        professionalMakeRecommendation, setprofessionalMakeRecommendation,
        employerSavingNotes, setemployerSavingNotes,
        employerClearNotes, setEmployerClearNotes,
        jobMakeRecommendation, setjobMakeRecommendation,
        superAdminJobSearch, setsuperAdminJobSearch,

        getEmployerDashboard,
        jobGlow, setJobGlow,
        jobs, setJobs,
        jobsDuplicate, setJobsDuplicate,
        jobFilter, setJobFilter,
        jobFullDetails,
        selectedEmployer, setSelectedEmployer,
        handleIndividualEmployerCard,
        employerApplyFilterObject, setEmployerApplyFilterObject,
        employerLocationConvertion, setEmployerLocationConvertion,
        employerPlanConvertion, setEmployerPlanConvertion,
        employerSkillConvertion, setEmployerSkillConvertion,
        employerApplyFilterCount, setEmployerApplyFilterCount,
        employerApplyFilterLoading, setEmployerApplyFilterLoading,
        employerFilterskills, setEmployerFilterskills,
        employerFilterplans, setEmployerFilterplans,
        employerFilterplanStatus, setEmployerFilterplanStatus,
        employerFilterloaction, setEmployerFilterLoaction,
        initializeEmployerReset,
        Jobplans, setJobplans,
        mellieSearchJobPlans, setMellieSearchJobPlans,

        getPartnerDashboard,
        partnerFilterOpen, setPartnerFilterOpen,
        partnerGlow, setPartnerGlow,
        partnerCards, setPartnerCards,
        partnerCardsDupli, setPartnerCardsDupli,
        partnerFullDetails, setPartnerFullDetails,
        partnerSectors, setPartnerSectors,
        partnerLocations, setPartnerLocations,
        partnerTypes, setPartnerTypes,
        partnerPlans, setPartnerPlans,
        selectedPartnerCard,
        partnerApplyFilterCount, setPartnerApplyFilterCount,
        selectedPartnerLoading, setSelectedPartnerLoading,
        partnerApplyFilterLoading, setPartnerApplyFilterLoading,
        partnerApplyFilterObject, setPartnerApplyFilterObject,
        initializePartnerReset,
        parType, setParType,
        parPlan, setParPlan,
        parLoc, setParLoc,
        parSector, setparSector,
        selectedPartnerAds, setSelectedPartnerAds,
        setsuperAdminPartnerSearch, superAdminPartnerSearch,
        jobStatusSelect, setJobStatusSelect,

        handleAdminProfessionalMeilisearch,
        handleAdminEmployerlMeilisearch,
        handleAdminJobslMeilisearch,
        handleAdminPartnerMeilisearch

      }}
    >
      {children}
    </SuperAdminContext.Provider>
  );
};

export default SuperAdminContext;